import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bc052c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-summary" }
const _hoisted_2 = { "data-test": "mechanic" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Price", -1))
const _hoisted_5 = { "data-test": "price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Total Minted", -1))
const _hoisted_7 = { "data-test": "total-minted" }

import { BigNumber } from '@ethersproject/bignumber';
import { formatUnits } from '@ethersproject/units';
import { useClaimStore } from '@/store/claimStore';

type Props = {
  total: number;
  totalMax: number | null;
  cost: BigNumber;
  hasAllowlist: boolean;
  ercTwentySymbol: string;
  ercTwentyDecimals: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimSummary',
  props: {
    total: null,
    totalMax: null,
    cost: null,
    hasAllowlist: { type: Boolean },
    ercTwentySymbol: null,
    ercTwentyDecimals: null
  },
  setup(__props: any) {

const props = __props as {
  total: number;
  totalMax: number | null;
  cost: BigNumber;
  hasAllowlist: boolean;
  ercTwentySymbol: string;
  ercTwentyDecimals: number;
};

_useCssVars(_ctx => ({
  "4c2bdb4a": (_unref(store).clientColors.themeSecondary)
}))


const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(props.totalMax === null ? 'Open' : 'Limited') + " Edition", 1),
      (props.hasAllowlist)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Exclusive"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("dl", null, [
      _hoisted_4,
      _createElementVNode("dd", _hoisted_5, _toDisplayString((props.cost.eq(0) ? 'Free' : `${_unref(formatUnits)(props.cost, props.ercTwentyDecimals)} ${props.ercTwentySymbol}`)), 1),
      _hoisted_6,
      _createElementVNode("dd", _hoisted_7, _toDisplayString(props.total.toLocaleString()) + _toDisplayString(props.totalMax === null ? '' : ` / ${Math.max(props.totalMax, props.total).toLocaleString()}`), 1)
    ])
  ]))
}
}

})